import { SearchCriteria } from 'src/app/core/interfaces/search-criteria.interface';
import { AppInterface } from '../../../interfaces/app.interface';
import { FIELD_PRIORITY_WEIGHT, SEARCH_FIELD, SearchPriorityConfig } from 'src/app/core/interfaces/search-priority-config';

export class AppKeywordsCriteria implements SearchCriteria {
  getMatchScore(_app: AppInterface, _query: string): number {
    if (!_app.keywords) return 0;
    return _app.keywords.some((keyword) => {
      return keyword.toLowerCase().includes(_query);
    })
      ? 1
      : 0;
  }
  getRelevanceFieldWeightAndMatchScore(_app: AppInterface, _query: string): SearchPriorityConfig {
    return {
      relevanceField: SEARCH_FIELD.TAGS,
      fieldPriorityWeight: FIELD_PRIORITY_WEIGHT.TAGS,
      matchScore: this.getMatchScore(_app, _query)
    }
  }
}
